import * as React from 'react';
import {
  Button,
  PageSection,
  Title
} from '@patternfly/react-core';
import { useSiteConfig } from '../config/SiteConfigContext';

export interface IErrorProps {
  sampleProp?: string;
}

const currentDateTime = new Date().toLocaleString();

// eslint-disable-next-line prefer-const
let Error: React.FunctionComponent<IErrorProps> = () => {
  const site = useSiteConfig();
  const supportEmail = site?.supportEmail;
  const productName = site?.productName || 'QuickCheck';
  return (
  <PageSection hasBodyWrapper={false}>
    <Title headingLevel="h1" size="xl">Error</Title>

      <p>{currentDateTime} An error has occurred and our support team have been notified.</p>
      {supportEmail ? (
        <p>Please <Button variant="primary" component="a" href={`mailto:${supportEmail}?subject=${productName} error at ${currentDateTime}`}> Contact Support</Button> for further assistance.</p>
      ) : (
        <p>Please try again later.</p>
      )}

  </PageSection>
);
};

export { Error };
